import PropTypes from "prop-types";
import styled from "styled-components";
import StripeManagement from "../../StripeManagement";
import Typography from "../../Typography";
import { theme } from "../../../theme";
import {
	BlockHeader,
	BlockHeaderContent,
	EmptyStateText,
	SettingsBlock,
} from "./UserSettingsTabPrimitives";

function UserSettingsPaymentsTab({
	t,
	user,
	stripeStatus,
	refreshStripeStatus,
	setUser,
}) {
	const hasStripeAccount = Boolean(stripeStatus?.hasStripeAccount);

	return (
		<SettingsBlock>
			<BlockHeader>
				<BlockHeaderContent>
					<Typography
						as="h2"
						$variant="title-5-semibold"
						$variantMobile="body-1-medium"
						$variantTablet="body-1-medium"
					>
						{t("settings.payments.title")}
					</Typography>
				</BlockHeaderContent>
			</BlockHeader>
			{user && stripeStatus && refreshStripeStatus && setUser ? (
				<>
					<PaymentsIntro>
						{hasStripeAccount ? (
							<>
								<Typography as="p" $variant="body-1-semibold">
									{t("settings.payments.connectedTitle")}
								</Typography>
								<Typography
									as="p"
									$variant="body-2-medium"
									color={theme.colors.defaultWeak}
								>
									{t("settings.payments.connectedSubtitle")}
								</Typography>
							</>
						) : (
							<Typography as="p" $variant="body-1-medium">
								{t("settings.payments.setupSubtitle")}
							</Typography>
						)}
					</PaymentsIntro>
					<StripeManagement
						variant="simple"
						$plain={true}
						showMetrics={false}
						showReactivation={true}
						user={user}
						stripeStatus={stripeStatus}
						refreshStripeStatus={refreshStripeStatus}
						setUser={setUser}
					/>
				</>
			) : (
				<EmptyStateText>{t("settings.payments.loading")}</EmptyStateText>
			)}
		</SettingsBlock>
	);
}

const PaymentsIntro = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.sizing.xxxs};
	padding: ${({ theme }) => theme.sizing.sm};
	padding-bottom: ${({ theme }) => theme.sizing.md};
`;

UserSettingsPaymentsTab.propTypes = {
	t: PropTypes.func.isRequired,
	user: PropTypes.object,
	stripeStatus: PropTypes.object,
	refreshStripeStatus: PropTypes.func,
	setUser: PropTypes.func,
};

export default UserSettingsPaymentsTab;
